export const DEFAULT_BANK_TRANSACTION_TAGS = [
  "Commission",
  "Cisive",
  "Name Card",
  "Interest",
];

export const normalizeBankTransactionTags = (tags) => {
  if (!Array.isArray(tags)) return [];

  const seen = new Set();
  const result = [];
  for (const tag of tags) {
    const trimmed = String(tag ?? "").trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    result.push(trimmed);
  }
  return result;
};

export const mergeBankTransactionTagOptions = (...lists) =>
  normalizeBankTransactionTags([
    ...DEFAULT_BANK_TRANSACTION_TAGS,
    ...lists.flat(),
  ]);
